import React from 'react';

export function CharacterINTJ({ size = 120 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="54" fill="#EDE9FE"/>
      <ellipse cx="60" cy="78" rx="28" ry="20" fill="#7C3AED" opacity="0.9"/>
      <path d="M38 52 Q60 28 82 52 Q75 45 60 43 Q45 45 38 52Z" fill="#5B21B6"/>
      <circle cx="60" cy="53" r="13" fill="#FDDCB5"/>
      <ellipse cx="55" cy="51" rx="3" ry="2" fill="#1E1B4B"/>
      <ellipse cx="65" cy="51" rx="3" ry="2" fill="#1E1B4B"/>
      <path d="M52 48 L58 49" stroke="#5B21B6" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M62 49 L68 48" stroke="#5B21B6" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M56 57 Q60 59 64 57" stroke="#C4963A" strokeWidth="1.2" fill="none" strokeLinecap="round"/>
      <rect x="52" y="68" width="16" height="3" rx="1.5" fill="#4C1D95"/>
      <rect x="55" y="62" width="10" height="7" rx="2" fill="#6D28D9"/>
      <circle cx="60" cy="60" r="4" fill="#7C3AED"/>
    </svg>
  );
}

export function CharacterINTP({ size = 120 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="54" fill="#DBEAFE"/>
      <ellipse cx="60" cy="78" rx="26" ry="18" fill="#2563EB" opacity="0.85"/>
      <circle cx="60" cy="52" r="15" fill="#FEF3C7"/>
      <path d="M46 65 L54 60 L60 63 L66 60 L74 65" fill="#EFF6FF" stroke="#93C5FD" strokeWidth="1"/>
      <circle cx="54" cy="51" r="5" fill="none" stroke="#1D4ED8" strokeWidth="1.5"/>
      <circle cx="66" cy="51" r="5" fill="none" stroke="#1D4ED8" strokeWidth="1.5"/>
      <line x1="59" y1="51" x2="61" y2="51" stroke="#1D4ED8" strokeWidth="1.5"/>
      <line x1="49" y1="51" x2="46" y2="49" stroke="#1D4ED8" strokeWidth="1.5"/>
      <line x1="71" y1="51" x2="74" y2="49" stroke="#1D4ED8" strokeWidth="1.5"/>
      <circle cx="54" cy="51" r="2" fill="#1E3A8A"/>
      <circle cx="66" cy="51" r="2" fill="#1E3A8A"/>
      <path d="M56 57 Q60 59 64 57" stroke="#C4963A" strokeWidth="1.2" fill="none"/>
      <text x="78" y="36" fontSize="8" fill="#2563EB" opacity="0.7">E=mc²</text>
      <text x="20" y="40" fontSize="10" fill="#2563EB" opacity="0.6">∑</text>
      <text x="85" y="55" fontSize="9" fill="#3B82F6" opacity="0.5">π</text>
      <text x="18" y="62" fontSize="8" fill="#2563EB" opacity="0.5">∞</text>
    </svg>
  );
}

export function CharacterENTJ({ size = 120 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="54" fill="#FFE4E6"/>
      <ellipse cx="60" cy="78" rx="27" ry="19" fill="#E11D48" opacity="0.9"/>
      <path d="M48 65 L56 72 L60 68 L64 72 L72 65 L68 62 L60 67 L52 62Z" fill="#9F1239"/>
      <circle cx="60" cy="50" r="14" fill="#FDDCB5"/>
      <ellipse cx="55" cy="48" rx="2.5" ry="2" fill="#111827"/>
      <ellipse cx="65" cy="48" rx="2.5" ry="2" fill="#111827"/>
      <path d="M53 45 L57 46.5" stroke="#9F1239" strokeWidth="1.5"/>
      <path d="M63 46.5 L67 45" stroke="#9F1239" strokeWidth="1.5"/>
      <path d="M55 55 Q60 57.5 65 55" stroke="#7F1D1D" strokeWidth="1.5" fill="none"/>
      <path d="M74 65 L88 55 L90 58 L76 68Z" fill="#E11D48"/>
      <circle cx="90" cy="56" r="4" fill="#FDDCB5"/>
    </svg>
  );
}

export function CharacterENTP({ size = 120 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="54" fill="#FFEDD5"/>
      <ellipse cx="60" cy="78" rx="26" ry="18" fill="#EA580C" opacity="0.85"/>
      <circle cx="60" cy="51" r="14" fill="#FEF9C3"/>
      <ellipse cx="60" cy="32" rx="12" ry="9" fill="#FDE68A" opacity="0.8"/>
      <rect x="56" y="38" width="8" height="5" rx="1" fill="#FCD34D"/>
      <line x1="60" y1="43" x2="60" y2="47" stroke="#FCD34D" strokeWidth="2"/>
      <line x1="60" y1="23" x2="60" y2="19" stroke="#F59E0B" strokeWidth="1.5"/>
      <line x1="72" y1="27" x2="75" y2="24" stroke="#F59E0B" strokeWidth="1.5"/>
      <line x1="48" y1="27" x2="45" y2="24" stroke="#F59E0B" strokeWidth="1.5"/>
      <line x1="76" y1="36" x2="80" y2="35" stroke="#F59E0B" strokeWidth="1.5"/>
      <line x1="44" y1="36" x2="40" y2="35" stroke="#F59E0B" strokeWidth="1.5"/>
      <ellipse cx="55" cy="49" rx="2.5" ry="2.5" fill="#1C1917"/>
      <ellipse cx="65" cy="49" rx="2.5" ry="2.5" fill="#1C1917"/>
      <path d="M52 46 Q55 44 58 46" stroke="#92400E" strokeWidth="1.2" fill="none"/>
      <path d="M62 46 Q65 44 68 46" stroke="#92400E" strokeWidth="1.2" fill="none"/>
      <path d="M53 55 Q60 62 67 55" stroke="#92400E" strokeWidth="1.5" fill="#FEF9C3"/>
    </svg>
  );
}

export function CharacterINFJ({ size = 120 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="54" fill="#DCFCE7"/>
      <circle cx="60" cy="60" r="38" fill="#BBF7D0" opacity="0.35"/>
      <circle cx="60" cy="60" r="26" fill="#6EE7B7" opacity="0.2"/>
      <ellipse cx="60" cy="78" rx="25" ry="17" fill="#16A34A" opacity="0.85"/>
      <circle cx="60" cy="51" r="14" fill="#ECFDF5"/>
      <path d="M52 50 Q55 48 58 50" stroke="#065F46" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
      <path d="M62 50 Q65 48 68 50" stroke="#065F46" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
      <path d="M55 56 Q60 59 65 56" stroke="#065F46" strokeWidth="1.3" fill="none" strokeLinecap="round"/>
      <circle cx="60" cy="44" r="2" fill="#10B981" opacity="0.7"/>
      <path d="M46 45 Q40 35 45 25 Q52 35 50 45" fill="#34D399" opacity="0.5"/>
      <path d="M74 45 Q80 35 75 25 Q68 35 70 45" fill="#34D399" opacity="0.5"/>
      <circle cx="25" cy="30" r="2" fill="#10B981" opacity="0.4"/>
      <circle cx="90" cy="35" r="2" fill="#10B981" opacity="0.4"/>
      <circle cx="20" cy="70" r="1.5" fill="#10B981" opacity="0.3"/>
      <circle cx="95" cy="65" r="1.5" fill="#10B981" opacity="0.3"/>
    </svg>
  );
}

export function CharacterINFP({ size = 120 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="54" fill="#EDE9FE"/>
      <ellipse cx="60" cy="80" rx="24" ry="16" fill="#7C3AED" opacity="0.75"/>
      <circle cx="60" cy="50" r="14" fill="#FDF4FF"/>
      <ellipse cx="55" cy="48" rx="3" ry="3.5" fill="#4C1D95"/>
      <ellipse cx="65" cy="48" rx="3" ry="3.5" fill="#4C1D95"/>
      <circle cx="56" cy="47" r="1" fill="white"/>
      <circle cx="66" cy="47" r="1" fill="white"/>
      <path d="M55 55 Q60 58 65 55" stroke="#6D28D9" strokeWidth="1.3" fill="none"/>
      <path d="M38 68 Q50 65 60 67 Q70 65 82 68 L80 80 Q70 78 60 80 Q50 78 40 80Z" fill="#F3E8FF" stroke="#A78BFA" strokeWidth="1"/>
      <line x1="60" y1="67" x2="60" y2="80" stroke="#A78BFA" strokeWidth="1"/>
      <line x1="44" y1="71" x2="58" y2="70" stroke="#C4B5FD" strokeWidth="0.8"/>
      <line x1="44" y1="74" x2="58" y2="73" stroke="#C4B5FD" strokeWidth="0.8"/>
      <line x1="62" y1="70" x2="76" y2="71" stroke="#C4B5FD" strokeWidth="0.8"/>
      <line x1="62" y1="73" x2="76" y2="74" stroke="#C4B5FD" strokeWidth="0.8"/>
      <text x="26" y="32" fontSize="9" fill="#A78BFA" opacity="0.6">★</text>
      <text x="84" y="27" fontSize="8" fill="#A78BFA" opacity="0.5">★</text>
      <text x="18" y="56" fontSize="7" fill="#A78BFA" opacity="0.4">✦</text>
      <text x="91" y="50" fontSize="7" fill="#A78BFA" opacity="0.4">✦</text>
    </svg>
  );
}

export function CharacterENFJ({ size = 120 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="54" fill="#CCFBF1"/>
      <line x1="60" y1="8" x2="60" y2="16" stroke="#5EEAD4" strokeWidth="2.5" opacity="0.5"/>
      <line x1="87" y1="15" x2="82" y2="22" stroke="#5EEAD4" strokeWidth="2.5" opacity="0.5"/>
      <line x1="106" y1="38" x2="99" y2="41" stroke="#5EEAD4" strokeWidth="2.5" opacity="0.5"/>
      <line x1="112" y1="63" x2="104" y2="63" stroke="#5EEAD4" strokeWidth="2.5" opacity="0.5"/>
      <line x1="33" y1="15" x2="38" y2="22" stroke="#5EEAD4" strokeWidth="2.5" opacity="0.5"/>
      <line x1="14" y1="38" x2="21" y2="41" stroke="#5EEAD4" strokeWidth="2.5" opacity="0.5"/>
      <line x1="8" y1="63" x2="16" y2="63" stroke="#5EEAD4" strokeWidth="2.5" opacity="0.5"/>
      <ellipse cx="60" cy="78" rx="26" ry="18" fill="#0D9488" opacity="0.9"/>
      <circle cx="60" cy="50" r="14" fill="#FDDCB5"/>
      <ellipse cx="55" cy="48" rx="2.5" ry="2.5" fill="#134E4A"/>
      <ellipse cx="65" cy="48" rx="2.5" ry="2.5" fill="#134E4A"/>
      <path d="M52 45 Q55 43 58 45" stroke="#0F766E" strokeWidth="1.3" fill="none"/>
      <path d="M62 45 Q65 43 68 45" stroke="#0F766E" strokeWidth="1.3" fill="none"/>
      <path d="M53 55 Q60 61 67 55" stroke="#0F766E" strokeWidth="1.8" fill="#F87171" strokeLinecap="round"/>
      <path d="M34 65 Q40 60 46 65" stroke="#0D9488" strokeWidth="4" fill="none" strokeLinecap="round"/>
      <path d="M74 65 Q80 60 86 65" stroke="#0D9488" strokeWidth="4" fill="none" strokeLinecap="round"/>
    </svg>
  );
}

export function CharacterENFP({ size = 120 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="54" fill="#FFEDD5"/>
      <ellipse cx="60" cy="82" rx="22" ry="14" fill="#EA580C" opacity="0.8"/>
      <circle cx="60" cy="50" r="13" fill="#FEF3C7"/>
      <ellipse cx="55" cy="48" rx="3.5" ry="4" fill="#1C1917"/>
      <ellipse cx="65" cy="48" rx="3.5" ry="4" fill="#1C1917"/>
      <circle cx="56.5" cy="47" r="1.2" fill="white"/>
      <circle cx="66.5" cy="47" r="1.2" fill="white"/>
      <path d="M52 55 Q60 62 68 55" stroke="#92400E" strokeWidth="1.8" fill="#FCA5A5"/>
      <path d="M20 35 Q28 28 30 35 Q28 42 20 35Z" fill="#FB923C" opacity="0.8"/>
      <path d="M38 35 Q30 28 30 35 Q30 42 38 35Z" fill="#FDBA74" opacity="0.8"/>
      <circle cx="30" cy="35" r="2" fill="#92400E"/>
      <path d="M82 28 Q90 21 92 28 Q90 35 82 28Z" fill="#FB923C" opacity="0.7"/>
      <path d="M100 28 Q92 21 92 28 Q92 35 100 28Z" fill="#FDBA74" opacity="0.7"/>
      <circle cx="92" cy="28" r="2" fill="#92400E"/>
      <path d="M47 63 Q38 55 32 50" stroke="#EA580C" strokeWidth="3.5" fill="none" strokeLinecap="round"/>
      <path d="M73 63 Q82 55 88 50" stroke="#EA580C" strokeWidth="3.5" fill="none" strokeLinecap="round"/>
    </svg>
  );
}

export function CharacterISTJ({ size = 120 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="54" fill="#DBEAFE"/>
      <ellipse cx="60" cy="78" rx="27" ry="19" fill="#1D4ED8" opacity="0.9"/>
      <rect x="55" y="63" width="10" height="14" fill="#1E40AF"/>
      <circle cx="60" cy="62" r="4.5" fill="#FCD34D"/>
      <text x="57" y="64" fontSize="5" fill="#1E3A8A" fontWeight="bold">★</text>
      <circle cx="60" cy="50" r="14" fill="#FDDCB5"/>
      <rect x="52" y="47" width="7" height="4" rx="2" fill="#1E3A8A"/>
      <rect x="61" y="47" width="7" height="4" rx="2" fill="#1E3A8A"/>
      <path d="M53 45 L59 46" stroke="#1E40AF" strokeWidth="1.5"/>
      <path d="M61 46 L67 45" stroke="#1E40AF" strokeWidth="1.5"/>
      <path d="M56 56 L64 56" stroke="#92400E" strokeWidth="1.3" strokeLinecap="round"/>
      <rect x="74" y="55" width="16" height="20" rx="2" fill="#EFF6FF" stroke="#93C5FD" strokeWidth="1"/>
      <rect x="76" y="52" width="12" height="5" rx="1" fill="#3B82F6"/>
      <line x1="76" y1="63" x2="88" y2="63" stroke="#93C5FD" strokeWidth="1"/>
      <line x1="76" y1="67" x2="88" y2="67" stroke="#93C5FD" strokeWidth="1"/>
      <line x1="76" y1="71" x2="84" y2="71" stroke="#93C5FD" strokeWidth="1"/>
    </svg>
  );
}

export function CharacterISFJ({ size = 120 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="54" fill="#DCFCE7"/>
      <ellipse cx="60" cy="78" rx="26" ry="18" fill="#15803D" opacity="0.85"/>
      <circle cx="60" cy="50" r="14" fill="#FDDCB5"/>
      <ellipse cx="55" cy="48" rx="3" ry="3" fill="#14532D"/>
      <ellipse cx="65" cy="48" rx="3" ry="3" fill="#14532D"/>
      <circle cx="56" cy="47" r="1" fill="white"/>
      <circle cx="66" cy="47" r="1" fill="white"/>
      <path d="M52 45.5 Q55 44 58 45.5" stroke="#166534" strokeWidth="1.2" fill="none"/>
      <path d="M62 45.5 Q65 44 68 45.5" stroke="#166534" strokeWidth="1.2" fill="none"/>
      <path d="M54 55 Q60 60 66 55" stroke="#166534" strokeWidth="1.5" fill="none"/>
      <ellipse cx="51" cy="54" rx="4" ry="2.5" fill="#FCA5A5" opacity="0.45"/>
      <ellipse cx="69" cy="54" rx="4" ry="2.5" fill="#FCA5A5" opacity="0.45"/>
      <path d="M30 52 L30 70 Q30 82 41 86 Q46 88 47 78 L47 52Z" fill="#4ADE80" stroke="#16A34A" strokeWidth="1.5"/>
      <path d="M35 62 L42 62" stroke="#15803D" strokeWidth="1.5"/>
      <path d="M38.5 58 L38.5 66" stroke="#15803D" strokeWidth="1.5"/>
    </svg>
  );
}

export function CharacterESTJ({ size = 120 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="54" fill="#FFE4E6"/>
      <ellipse cx="60" cy="78" rx="27" ry="19" fill="#BE123C" opacity="0.9"/>
      <path d="M45 65 L55 68 L60 65 L65 68 L75 65" stroke="#9F1239" strokeWidth="2" fill="none"/>
      <circle cx="60" cy="50" r="14" fill="#FDDCB5"/>
      <rect x="52" y="47" width="6" height="3.5" rx="1.5" fill="#881337"/>
      <rect x="62" y="47" width="6" height="3.5" rx="1.5" fill="#881337"/>
      <path d="M53 44 L57 45.5" stroke="#9F1239" strokeWidth="1.5"/>
      <path d="M63 45.5 L67 44" stroke="#9F1239" strokeWidth="1.5"/>
      <path d="M55 56 Q60 58 65 56" stroke="#7F1D1D" strokeWidth="1.3" fill="none"/>
      <rect x="22" y="70" width="34" height="22" rx="2" fill="#FFF1F2" stroke="#FECDD3" strokeWidth="1"/>
      <line x1="26" y1="76" x2="52" y2="76" stroke="#FDA4AF" strokeWidth="1"/>
      <line x1="26" y1="80" x2="52" y2="80" stroke="#FDA4AF" strokeWidth="1"/>
      <line x1="26" y1="84" x2="44" y2="84" stroke="#FDA4AF" strokeWidth="1"/>
      <circle cx="50" cy="84" r="3" fill="#E11D48"/>
      <path d="M48 84 L50 86 L53 82" stroke="white" strokeWidth="1.2" fill="none"/>
    </svg>
  );
}

export function CharacterESFJ({ size = 120 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="54" fill="#CCFBF1"/>
      <ellipse cx="60" cy="78" rx="26" ry="18" fill="#0F766E" opacity="0.9"/>
      <circle cx="60" cy="50" r="14" fill="#FDDCB5"/>
      <ellipse cx="55" cy="47" rx="3" ry="3" fill="#134E4A"/>
      <ellipse cx="65" cy="47" rx="3" ry="3" fill="#134E4A"/>
      <circle cx="56" cy="46" r="1.2" fill="white"/>
      <circle cx="66" cy="46" r="1.2" fill="white"/>
      <ellipse cx="51" cy="54" rx="4" ry="3" fill="#FCA5A5" opacity="0.5"/>
      <ellipse cx="69" cy="54" rx="4" ry="3" fill="#FCA5A5" opacity="0.5"/>
      <path d="M52 55 Q60 63 68 55" stroke="#0F766E" strokeWidth="2" fill="#F87171" strokeLinecap="round"/>
      <path d="M35 65 Q42 58 47 65" stroke="#0D9488" strokeWidth="4" fill="none" strokeLinecap="round"/>
      <path d="M73 65 Q78 58 85 65" stroke="#0D9488" strokeWidth="4" fill="none" strokeLinecap="round"/>
      <path d="M57 38 Q60 34 63 38 Q66 42 60 47 Q54 42 57 38Z" fill="#F87171"/>
    </svg>
  );
}

export function CharacterISTP({ size = 120 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="54" fill="#DBEAFE"/>
      <ellipse cx="60" cy="78" rx="26" ry="18" fill="#1D4ED8" opacity="0.85"/>
      <circle cx="60" cy="50" r="14" fill="#FDDCB5"/>
      <rect x="53" y="47" width="6" height="3" rx="1.5" fill="#1E3A8A"/>
      <rect x="61" y="47" width="6" height="3" rx="1.5" fill="#1E3A8A"/>
      <path d="M55 55 L65 55" stroke="#92400E" strokeWidth="1.2" strokeLinecap="round"/>
      <rect x="73" y="58" width="5" height="20" rx="2.5" fill="#94A3B8" transform="rotate(-25 75 68)"/>
      <circle cx="76" cy="54" r="6" fill="#64748B" stroke="#475569" strokeWidth="1.2"/>
      <circle cx="76" cy="54" r="3" fill="#94A3B8"/>
      <ellipse cx="82" cy="70" rx="7" ry="5" fill="#3B82F6" opacity="0.8"/>
    </svg>
  );
}

export function CharacterISFP({ size = 120 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="54" fill="#CCFBF1"/>
      <ellipse cx="60" cy="78" rx="25" ry="17" fill="#0D9488" opacity="0.8"/>
      <circle cx="60" cy="50" r="13" fill="#FDDCB5"/>
      <ellipse cx="55" cy="48" rx="3" ry="3.5" fill="#0F4C75"/>
      <ellipse cx="65" cy="48" rx="3" ry="3.5" fill="#0F4C75"/>
      <circle cx="56" cy="47" r="1" fill="white"/>
      <circle cx="66" cy="47" r="1" fill="white"/>
      <path d="M55 55 Q60 58 65 55" stroke="#0F766E" strokeWidth="1.2" fill="none"/>
      <rect x="76" y="48" width="4" height="22" rx="2" fill="#92400E" transform="rotate(-18 78 59)"/>
      <ellipse cx="80" cy="47" rx="3.5" ry="5.5" fill="#34D399" transform="rotate(-18 80 47)"/>
      <circle cx="28" cy="38" r="5" fill="#F9A8D4" opacity="0.8"/>
      <circle cx="28" cy="38" r="2.5" fill="#EC4899"/>
      <circle cx="22" cy="56" r="4" fill="#FDE68A" opacity="0.8"/>
      <circle cx="22" cy="56" r="2" fill="#F59E0B"/>
      <circle cx="90" cy="42" r="4.5" fill="#A7F3D0" opacity="0.8"/>
      <circle cx="90" cy="42" r="2" fill="#10B981"/>
    </svg>
  );
}

export function CharacterESTP({ size = 120 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="54" fill="#FFE4E6"/>
      <ellipse cx="60" cy="80" rx="26" ry="17" fill="#DC2626" opacity="0.9"/>
      <circle cx="60" cy="49" r="13" fill="#FDDCB5"/>
      <ellipse cx="55" cy="47" rx="3" ry="3" fill="#1C1917"/>
      <ellipse cx="65" cy="47" rx="3" ry="3" fill="#1C1917"/>
      <circle cx="56.2" cy="46" r="1.2" fill="white"/>
      <circle cx="66.2" cy="46" r="1.2" fill="white"/>
      <path d="M52 44 L57 46" stroke="#991B1B" strokeWidth="1.5"/>
      <path d="M63 46 L68 44" stroke="#991B1B" strokeWidth="1.5"/>
      <path d="M53 55 Q60 61 67 55" stroke="#7F1D1D" strokeWidth="1.8" fill="#FCA5A5"/>
      <line x1="20" y1="30" x2="32" y2="22" stroke="#FCA5A5" strokeWidth="2" strokeLinecap="round"/>
      <line x1="15" y1="50" x2="25" y2="48" stroke="#FCA5A5" strokeWidth="2" strokeLinecap="round"/>
      <line x1="18" y1="70" x2="28" y2="68" stroke="#FCA5A5" strokeWidth="2" strokeLinecap="round"/>
      <path d="M85 22 Q90 12 96 18 Q93 28 86 33 Q84 28 85 22Z" fill="#EF4444"/>
      <path d="M85 33 Q80 38 78 43 L82 41Z" fill="#FCA5A5"/>
      <circle cx="90" cy="20" r="2.5" fill="#FEF2F2"/>
    </svg>
  );
}

export function CharacterESFP({ size = 120 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" fill="none">
      <circle cx="60" cy="60" r="54" fill="#FFEDD5"/>
      <path d="M58 8 L62 8 L65 50 L60 55 L55 50Z" fill="#FDE68A" opacity="0.45"/>
      <ellipse cx="60" cy="78" rx="26" ry="18" fill="#C2410C" opacity="0.9"/>
      <circle cx="60" cy="50" r="14" fill="#FDDCB5"/>
      <ellipse cx="55" cy="47" rx="3.5" ry="4" fill="#1C1917"/>
      <ellipse cx="65" cy="47" rx="3.5" ry="4" fill="#1C1917"/>
      <circle cx="56.5" cy="46" r="1.3" fill="white"/>
      <circle cx="66.5" cy="46" r="1.3" fill="white"/>
      <ellipse cx="50" cy="54" rx="5" ry="3.5" fill="#FCA5A5" opacity="0.5"/>
      <ellipse cx="70" cy="54" rx="5" ry="3.5" fill="#FCA5A5" opacity="0.5"/>
      <path d="M51 56 Q60 64 69 56" stroke="#92400E" strokeWidth="2" fill="#F87171" strokeLinecap="round"/>
      <circle cx="32" cy="52" r="5" fill="#FDDCB5"/>
      <line x1="29" y1="49" x2="25" y2="44" stroke="#FDDCB5" strokeWidth="2.2"/>
      <line x1="32" y1="47" x2="31" y2="42" stroke="#FDDCB5" strokeWidth="2.2"/>
      <line x1="35" y1="49" x2="38" y2="44" stroke="#FDDCB5" strokeWidth="2.2"/>
      <circle cx="88" cy="52" r="5" fill="#FDDCB5"/>
      <line x1="85" y1="49" x2="82" y2="44" stroke="#FDDCB5" strokeWidth="2.2"/>
      <line x1="88" y1="47" x2="89" y2="42" stroke="#FDDCB5" strokeWidth="2.2"/>
      <line x1="91" y1="49" x2="95" y2="44" stroke="#FDDCB5" strokeWidth="2.2"/>
      <text x="19" y="28" fontSize="11" fill="#F59E0B" opacity="0.7">★</text>
      <text x="89" y="25" fontSize="9" fill="#F59E0B" opacity="0.6">★</text>
      <text x="30" y="90" fontSize="8" fill="#F59E0B" opacity="0.4">✦</text>
      <text x="85" y="88" fontSize="7" fill="#F59E0B" opacity="0.4">✦</text>
    </svg>
  );
}

export const TYPE_CHARACTERS = {
  INTJ: CharacterINTJ, INTP: CharacterINTP, ENTJ: CharacterENTJ, ENTP: CharacterENTP,
  INFJ: CharacterINFJ, INFP: CharacterINFP, ENFJ: CharacterENFJ, ENFP: CharacterENFP,
  ISTJ: CharacterISTJ, ISFJ: CharacterISFJ, ESTJ: CharacterESTJ, ESFJ: CharacterESFJ,
  ISTP: CharacterISTP, ISFP: CharacterISFP, ESTP: CharacterESTP, ESFP: CharacterESFP,
};

export default TYPE_CHARACTERS;
